import React from 'react';
import { isNil } from 'lodash';
import Anchor from '../../../../components/link/Anchor';

const OpenOrderModifyDeliveryInfo = (props) => {
  const { text = '이력보기', orderItemId, getOrderDeliveryModifyData } = props;

  /**
   * 링크로 연결할 데이터가 없다면
   * '-' 를 반환함
   */
  if (isNil(orderItemId) || !getOrderDeliveryModifyData) {
    return '-';
  }

  return (
    <Anchor
      color="primary"
      isUnderLine
      text={text}
      onClick={() =>
        getOrderDeliveryModifyData({
          orderItemId,
        })
      }
    />
  );
};

export default OpenOrderModifyDeliveryInfo;
